import { Icons, Inline, Spinner, Stack, Text } from "@sembark-travel/ui-base"
import { Navigate } from "react-router"
import { generatePath } from "../../../../../router-utils"
import { useTripWhatsApp } from "../../../../../Trips/store"
import { useTripDetailsOutletContext } from "../_trip-details-context"

export default function TripWhatsAppIndexPage() {
	const { trip } = useTripDetailsOutletContext()
	const tripId = Number(trip.id)
	const { overview, isLoading } = useTripWhatsApp(tripId)
	const threads = overview?.threads || []

	if (!overview && isLoading) {
		return <Spinner alignCenter padding="4" />
	}

	// With a single conversation there is nothing to choose between, so open it.
	if (threads.length === 1) {
		return (
			<Navigate
				replace
				to={generatePath("/trips/:tripId/whatsapp/:threadId", {
					tripId: String(tripId),
					threadId: String(threads[0].id),
				})}
			/>
		)
	}

	return (
		<Inline
			height="full"
			alignItems="center"
			justifyContent="center"
			padding="4"
		>
			<Stack gap="2" alignItems="center">
				<Text color="muted" fontSize="3xl">
					<Icons.Chat />
				</Text>
				<Text color="muted">
					{threads.length
						? "Select a conversation to open it here."
						: "No WhatsApp conversations are linked to this trip yet."}
				</Text>
			</Stack>
		</Inline>
	)
}
